import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-sitemap',
  imports: [MainLayout, MarginWrapper],
  template: `
    <allas-main-layout>
      <allas-margin-wrapper styleClass="fs-condensed my-16">
        <!-- Título principal -->
        <h1 class="text-4xl font-bold text-gray-800 mb-12">MAPA DEL SITIO</h1>

        <!-- Contenedor de columnas -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <!-- Columna 1: Mi Cuenta y Mi Garage -->
          <div class="space-y-6">
            <div>
              <h2
                class="text-xl font-bold text-gray-800 border-b-2 border-allasRed pb-2 mb-4"
              >
                MI CUENTA
              </h2>
              <ul class="space-y-2">
                <li>
                  <a
                    href="/login"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Iniciar sesión
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 class="text-lg font-bold text-gray-800 mb-3">GARAGE</h3>
              <ul class="space-y-2">
                <li>
                  <a
                    href="/garage"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Mi Auto
                  </a>
                </li>
                <li>
                  <a
                    href="/tienda"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Mi Tienda
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Columna 2: Comprar -->
          <div class="space-y-6">
            <div>
              <h2
                class="text-xl font-bold text-gray-800 border-b-2 border-allasRed pb-2 mb-4"
              >
                COMPRAR
              </h2>
              <ul class="space-y-2">
                <li>
                  <a
                    href="/repuestos/bateria-para-carro-auto-o-camioneta"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Encuentra tu Batería
                  </a>
                </li>
                <li>
                  <a
                    href="/comprar/marca"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Comprar por Marca
                  </a>
                </li>
                <li>
                  <a
                    href="/comprar/modelo"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Comprar por Modelo
                  </a>
                </li>
                <li>
                  <a
                    href="/comprar/marca-producto"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Comprar por Marca de Producto
                  </a>
                </li>
                <li>
                  <a
                    href="/repuestos"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Catálogo de Repuestos
                  </a>
                </li>
                <li>
                  <a
                    href="/bajo-construccion"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Ofertas y Liquidaciones
                  </a>
                </li>
                <li>
                  <a
                    href="/bajo-construccion"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Lista de Deseos (próximamente)
                  </a>
                </li>
                <li>
                  <a
                    href="/carrito"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Mi Carrito
                  </a>
                </li>
                <li>
                  <a
                    href="/encuentra-tu-tienda"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Encuentra tu Tienda
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Columna 3: Servicios -->
          <div class="space-y-6">
            <div>
              <h2
                class="text-xl font-bold text-gray-800 border-b-2 border-allasRed pb-2 mb-4"
              >
                SERVICIOS
              </h2>
              <ul class="space-y-2">
                <li>
                  <a
                    href="/servicios/diagnostico-instalacion-baterias"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Diagnóstico de Batería
                  </a>
                </li>
                <li>
                  <a
                    href="/servicios/diagnostico-instalacion-baterias"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Instalación de Batería
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/entrega-domicilio"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Servicio a Domicilio
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/cambiar-limpiaparabrisas"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Instalación de Limpiaparabrisas
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/instalacion-filtros"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Instalación de Filtros
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/reciclaje-baterias"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Reciclaje de Baterías
                  </a>
                </li>
                <li>
                  <a
                    href="encuentra-tu-tienda"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Tiendas Allas Cerca de Mi
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/talleres-referidos"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Talleres Referidos
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/entrega-domicilio"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Compras en Línea y Recoge en Tienda
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/aplicacion-mobile"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Aplicación Mobile
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/afiliacion"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Programa de Beneficios o Puntos
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/contactanos"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Cotización por WhatsApp
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Columna 4: Nuestra Empresa, Ayuda y Términos -->
          <div class="space-y-6">
            <div>
              <h2
                class="text-xl font-bold text-gray-800 border-b-2 border-allasRed pb-2 mb-4"
              >
                NUESTRA EMPRESA
              </h2>
              <ul class="space-y-2">
                <li>
                  <a
                    href="empresa/sobre-nosotros"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Sobre Nosotros
                  </a>
                </li>
                <li>
                  <a
                    href="sucursales"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Nuestras Sucursales
                  </a>
                </li>
                <li>
                  <a
                    href="empresa/bolsa-empleo"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Trabaja con Nosotros
                  </a>
                </li>
                <li>
                  <a
                    href="servicios/afiliaciones"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Programa de Afiliados
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 class="text-lg font-bold text-gray-800 mb-3">AYUDA</h3>
              <ul class="space-y-2">
                <li>
                  <a
                    href="contactanos"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Contáctanos
                  </a>
                </li>
                <!-- <li>
                  <a
                    href="ayuda/mi-cuenta"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Mi Cuenta
                  </a>
                </li>
                <li>
                  <a
                    href="ayuda/rastrear-mi-pedido"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Rastrear mi Pedido
                  </a>
                </li> -->
                <li>
                  <a
                    href="ayuda/preguntas-frecuentes"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Preguntas Frecuentes
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 class="text-lg font-bold text-gray-800 mb-3">
                TÉRMINOS Y CONDICIONES
              </h3>
              <ul class="space-y-2">
                <li>
                  <a
                    href="privacidad"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Política de Garantías
                  </a>
                </li>
                <li>
                  <a
                    href="privacidad"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Política de Cambios
                  </a>
                </li>
                <li>
                  <a
                    href="privacidad"
                    class="text-gray-700 hover:text-allasRed transition-colors"
                  >
                    Política de Devoluciones
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class Sitemap implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle = 'Mapa del Sitio | Allas Repuestos';
    const description =
      'Navega fácilmente por todas las secciones de Allas Repuestos. Encuentra repuestos, servicios, tiendas y más con envío a domicilio en Honduras.';
    const keywords =
      'mapa del sitio, Allas Repuestos, repuestos, servicios, tiendas, envío a domicilio, Honduras, navegación';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
